/* CYL Labor Day 3+1 cart-drawer hint (September 2026 campaign).
   The drawer's _render() rebuilds .cd-body innerHTML from JS templates on
   every cart:updated, wiping Liquid-rendered rows, so this hint is injected
   client-side (same pattern as the retired cyl-shiloh-hint.js). The Liquid
   row in sections/cart-drawer.liquid covers first paint only; this file owns
   the row from the first cart:updated onward.
   States (qualifying items counted across the product ids below):
     1 to 3: counter pill "N of 4" + nudge copy + Browse keepsakes link
     4+:     3+1 chip + "applied" line naming the free item, plus footer rows
             Subtotal (pre-discount) / Labor Day 3+1 -amount / Total, with the
             checkout button showing the discounted total.
   Also sets body.cyl-labor-complete and body[data-cyl-labor-complete] at 4+
   so the Klaviyo popup can be suppressed with CSS.
   Product ids mirror automatic BXGY discount DiscountAutomaticNode/1785656770927.
   Teardown with the campaign: remove this file and its script tag in
   sections/cart-drawer.liquid (teardown.sh flips the Liquid flag that
   emits the tag). */
(function () {
  var IDS = [
    14717716300143, 14718228791663, 14727252476271, 14865643012463, 14882821800303,
    14946849096047, 14998952935791, 15015528137071, 15031637246319, 15031637770607,
    15034815807855, 15057749967215, 15062648521071, 14945723613551,
    14992466903407, 14992473784687, 14992474767727
  ];
  var HINT_ID = 'cyl-labor-hint';
  var BODY_CLASS = 'cyl-labor-complete';
  var BROWSE = ' <a href="/collections/all" style="color:#B8956A;text-decoration:underline;white-space:nowrap;">Browse keepsakes</a>';
  var CHIP = 'flex:none;background:#B8956A;color:#FFFFFF;font-family:Montserrat,Arial,sans-serif;font-weight:700;font-size:12px;letter-spacing:0.5px;padding:6px 8px;';

  function money(cents) {
    try {
      if (window.Shopify && window.Shopify.formatMoney && window.cartDrawerSettings && window.cartDrawerSettings.moneyFormat) {
        return window.Shopify.formatMoney(cents, window.cartDrawerSettings.moneyFormat);
      }
    } catch (e) {}
    return '$' + (Math.abs(cents) / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* qty of qualifying items, the cheapest qualifying line (lowest unit price),
     and any discount Shopify has already applied to qualifying lines (once the
     automatic discount is ACTIVE cart.js reflects it in final_line_price). */
  function analyse(cart) {
    var qty = 0, cheapest = null, applied = 0;
    (cart.items || []).forEach(function (it) {
      if (IDS.indexOf(it.product_id) === -1) return;
      qty += it.quantity;
      var unit = (typeof it.final_price === 'number' ? it.final_price : it.price);
      if (!cheapest || unit < cheapest.price) cheapest = { title: String(it.product_title || it.title || '').replace(/^The\s+/, ''), price: unit };
      var orig = it.original_line_price != null ? it.original_line_price : it.line_price;
      var fin = it.final_line_price != null ? it.final_line_price : it.line_price;
      if (orig > fin) applied += (orig - fin);
    });
    return { qty: qty, cheapest: cheapest, applied: applied };
  }

  function copyFor(a) {
    if (a.qty === 1) return '<strong>Labor Day 3+1:</strong> add any 3 more keepsakes and the lowest priced one is free.' + BROWSE;
    if (a.qty === 2) return '<strong>Labor Day 3+1:</strong> add 2 more keepsakes and the lowest priced one is free.' + BROWSE;
    if (a.qty === 3) return '<strong>One away.</strong> Add 1 more keepsake and the lowest priced one is free.' + BROWSE;
    var amount = a.applied > 0 ? a.applied : (a.cheapest ? a.cheapest.price : 0);
    return '<strong>Labor Day 3+1 applied:</strong> your ' + esc(a.cheapest ? a.cheapest.title : 'lowest priced keepsake') + ' (' + esc(money(amount)) + ') is free at checkout.';
  }

  function setComplete(on) {
    var b = document.body;
    if (!b) return;
    if (on) { b.classList.add(BODY_CLASS); b.setAttribute('data-cyl-labor-complete', '1'); }
    else { b.classList.remove(BODY_CLASS); b.removeAttribute('data-cyl-labor-complete'); }
  }

  /* Footer: Subtotal (pre-discount) / Labor Day 3+1 -amount / Total, and the
     checkout button shows the discounted total. cart-drawer.js writes its own
     subtotal on every cart:updated before this runs, so these are re-applied
     each time. Once the discount is ACTIVE cart.total_price is already net and
     the amount is Shopify's applied discount; before that it is computed. */
  function renderTotals(cart, a) {
    var disc = document.querySelector('[data-cyl-labor-discount]');
    var tot = document.querySelector('[data-cyl-labor-total]');
    if (!disc || !tot) return;
    if (!cart || a.qty < 4 || !a.cheapest) { disc.hidden = true; tot.hidden = true; return; }
    var original = (cart.items || []).reduce(function (s, it) {
      return s + (it.original_line_price != null ? it.original_line_price : it.line_price);
    }, 0);
    var amount, total;
    if (a.applied > 0) { amount = original - cart.total_price; total = cart.total_price; }
    else { amount = a.cheapest.price; total = cart.total_price - amount; }
    var sub = document.querySelector('#cart-drawer [data-cd-subtotal]');
    var strike = document.querySelector('#cart-drawer [data-cd-original]');
    var cta = document.querySelector('#cart-drawer [data-cd-cta-subtotal]');
    if (sub) sub.textContent = money(original);
    if (strike) strike.hidden = true;
    var amt = disc.querySelector('[data-cyl-labor-discount-amount]');
    if (amt) amt.textContent = '-' + money(amount);
    var tamt = tot.querySelector('[data-cyl-labor-total-amount]');
    if (tamt) tamt.textContent = money(total);
    if (cta) cta.textContent = money(total);
    disc.hidden = false; tot.hidden = false;
  }

  function render(cart) {
    var existing = document.getElementById(HINT_ID);
    if (existing) existing.remove();
    if (!cart || !cart.items || !cart.items.length) { setComplete(false); renderTotals(null, { qty: 0 }); return; }
    var a = analyse(cart);
    setComplete(a.qty >= 4);
    renderTotals(cart, a);
    if (a.qty < 1) return;
    var host = document.querySelector('#cart-drawer .cd-items');
    if (!host) return;
    var badge = a.qty >= 4 ? '3+1' : (a.qty + ' of 4');
    var div = document.createElement('div');
    div.id = HINT_ID;
    div.className = 'cd-item';
    div.style.cssText = 'background:#F5F1E8;border:1px solid #B8956A;padding:10px 14px;display:flex;align-items:center;gap:10px;';
    div.innerHTML =
      '<div style="' + CHIP + (a.qty >= 4 ? '' : 'white-space:nowrap;') + '">' + badge + '</div>' +
      '<div style="font-family:Heebo,Arial,sans-serif;font-size:13px;color:#3E2723;min-width:0;">' + copyFor(a) + '</div>';
    host.insertBefore(div, host.firstChild);
  }

  document.addEventListener('cart:updated', function (e) {
    render(e.detail && e.detail.cart);
  });

  function boot() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
